<div title="{{item.value.label | translate}}" class="ui-multiselect-item-custom
                                    {{item.value.preferred?'multiselect-bg-white':'multiselect-bg-gray'}}
                                    {{item.separator?'item-separator':''}}">
  <div class="checkbox">
    <!-- tabindex="-1" + aria-hidden: this checkbox is a visual affordance only.
         The ARIA listbox pattern exposes selection state through aria-selected on
         the parent <li role="option"> (managed by PrimeNG via aria-activedescendant
         on the combobox input). Making it a Tab stop would force keyboard users to
         Tab through every option instead of using Arrow keys (WCAG 2.1.1). -->
    <input type="checkbox" tabindex="-1" aria-hidden="true" [checked]="item.isSelected" [disabled]="item.isReadOnly"/>
    <label class="ui-multiselect-option-label" [ngClass]="{'read-only':item.isReadOnly}">
      <span class="label-text">{{item.value.label | translate}}</span>
    </label>
  </div>
</div>
